import { render } from "./DColorPicker.vue?vue&type=template&id=70b5fedc&scoped=true"
import script from "./DColorPicker.vue?vue&type=script&lang=js"
export * from "./DColorPicker.vue?vue&type=script&lang=js"

import "./DColorPicker.vue?vue&type=style&index=0&id=70b5fedc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b5fedc"]])

export default __exports__